// message.js
import Vue from "vue"; // 引入 Vue 是因为要用到 Vue.extend() 这个方法
import message from "./message.vue"; // 引入刚才的 msg 组件

let messageConstructor = Vue.extend(message); 
let instance;

const Message = function (options = {}) {
    instance = new messageConstructor({
			data:options
		}).$mount(); // 渲染组件
    document.body.appendChild(instance.$el); // 挂载到 body 下
};
export default Message;


// WEBPACK FOOTER //
// ./src/components/message/message.js